// useful for rewiring fetch in tests

export default function whatwgFetch(url, options) {
  return fetch(url, options);
}
